import { TRAINING_CONTENT } from '../../constants';
import { ContentPaper, ContentText, BoldText } from './styles';
import { SectionTitle } from '../HowWeWorkSection/styles';
import { Box } from '@mui/system';

const TrainingSection = () => {
  return (
    <Box>
      <SectionTitle>{TRAINING_CONTENT.title}</SectionTitle>

      <ContentPaper elevation={0}>
        <ContentText>
          {TRAINING_CONTENT.description}
          <BoldText>{TRAINING_CONTENT.boldText1}</BoldText>
          {TRAINING_CONTENT.middleText}
          <BoldText>{TRAINING_CONTENT.boldText2}</BoldText>
          {TRAINING_CONTENT.endText}
        </ContentText>
      </ContentPaper>
    </Box>
  );
};

export default TrainingSection;
